import TableList from "app/components/organisms/TableList";
import { AssessmentsPath } from "app/constants/routePaths";
import { useGetAdminAssessmentIndexQuery } from "app/services/api/adminAssessmentsApi";
import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { AssessmentModel } from "app/services/api/types/forms/models/AssessmentModel";
import { View } from "ui/atoms/view";
import ViewMore from "ui/molecules/common/ViewMore";
import { Text } from "react-native";
import { snakeToSentence } from "ui/utils/textUtils";

export function AssessmentsTableTemplate() {
  const { data, isFetching } = useGetAdminAssessmentIndexQuery({});
  const columns: ColumnModel<AssessmentModel>[] = [
    {
      title: "ID",
      dataKey: "id",
    },
    {
      title: "Name",
      dataKey: "name",
    },
    {
      title: "Tag",
      dataKey: "tag",
      renderCell: (form) => {
        return <Text>{snakeToSentence(form.tag)}</Text>;
      },
    },
    {
      renderCell: (form) => {
        return (
          <View className="flex items-end">
            <ViewMore />
          </View>
        );
      },
    },
  ];

  return (
    <TableList
      columns={columns}
      data={data || []}
      isFetching={isFetching}
      emptyMessage="No assessments available."
      clickablePath={(form) => `${AssessmentsPath}/${form.id}`}
    />
  );
}
